import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Cookies from "js-cookie";
import { logOut, setAccessToken } from "../utils/api";

const Login = () => import("@/components/Login");
const Restaurants = () => import("@/components/Restaurants");
const GuestRestaurants = () => import("@/components/Guest/Restaurants");
const Profile = () => import("@/components/user/Profile");
const MyOrders = () => import("@/components/user/MyOrders");
const OrderDetail = () => import("@/components/user/OrderDetail");
const ForgotPassword = () => import("@/components/ForgotPassword");
const ResetPassword = () => import("@/components/ResetPassword");
const CreatePassword = () => import("@/components/CreatePassword");
const InstructionsSent = () => import("@/components/InstructionsSent");
const Payment = () => import("@/components/Payment");
const GuestPayment = () => import("@/components/Guest/Payment");
const Faq = () => import("@/components/Faq");
const TermsOfUse = () => import("@/components/TermsOfUse");
const Error404 = () => import("@/components/common/Error404");
const OfficeAdmin = () => import("@/components/OfficeAdmin/OfficeAdmin");
const OfficeEmployees = () =>
  import("@/components/OfficeAdmin/OfficeEmployees");
const RestaurantOrdersDetail = () =>
  import("@/components/OfficeAdmin/RestaurantOrdersDetail");
const PlaceOrder = () =>
  import("@/components/OfficeAdmin/PlaceOrder/PlaceOrder");
const Teams = () => import("@/components/OfficeAdmin/Teams/Teams");
const TeamDetail = () => import("@/components/OfficeAdmin/Teams/TeamDetail");
const OrderSuccess = () => import("@/components/Guest/OrderSuccess");
const LinkExpired = () => import("@/components/Guest/LinkExpired");

import { isLoggedIn, clearPKToken, getEmployeeProfile } from "@/utils/api";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/get-started/step2",
      name: "Login",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/office/do_login_admin",
      name: "AdminLogin",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/restaurants",
      name: "Restaurants",
      component: Restaurants,
      meta: { private: true }
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: { private: true }
    },
    {
      path: "/orders",
      name: "Orders",
      component: MyOrders,
      meta: { private: true }
    },
    {
      path: "/forget-password",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/office/reset_password",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/create_password",
      name: "Create Password",
      component: CreatePassword
    },
    {
      path: "/new-account",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/new_account",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/reset-password",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/instructions-sent",
      name: "InstructionsSent",
      component: InstructionsSent
    },
    {
      path: "/payment",
      name: "Payment",
      component: Payment,
      meta: { private: true }
    },
    {
      path: "/orderdetail",
      name: "OrderDetail",
      component: OrderDetail
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
      meta: { private: true }
    },
    {
      path: "/terms-of-use",
      name: "TermsOfUse",
      component: TermsOfUse,
      meta: { private: true }
    },
    {
      path: "/admin/restaurant-orders/:restaurant",
      name: "RestaurantOrdersDetail",
      component: RestaurantOrdersDetail,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin/teams/:team",
      name: "team-detail",
      component: TeamDetail,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin",
      name: "OfficeAdmin",
      component: OfficeAdmin,
      meta: { officeAdmin: true, private: true }
    },
    // {
    //   path: "/office-orders",
    //   name: "OfficeOrders",
    //   component: OfficeOrders
    // },
    {
      path: "/admin/users",
      name: "office-employees",
      component: OfficeEmployees,
      meta: { officeAdmin: true, private: true }
    },

    {
      path: "/admin/order",
      name: "place-order",
      component: PlaceOrder,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin/teams",
      name: "office-teams",
      component: Teams,
      meta: { officeAdmin: true, private: true }
    },
    //For invitation links
    {
      path: "/guest/restaurants/:slug",
      name: "Restaurants",
      component: GuestRestaurants
    },
    {
      path: "/guest/payments/:uncheckedoutOrderId/:slug",
      name: "GuestPayment",
      component: GuestPayment
    },
    {
      path: "/guest/confirmation",
      name: "OrderSuccess",
      component: OrderSuccess
    },
    {
      path: "/guest/link-expired",
      name: "LinkExpired",
      component: LinkExpired
    },
    {
      path: "/*",
      name: "Error404",
      component: Error404,
      meta: {
        error404: true
      }
    }
  ]
});

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return new Promise((resolve, reject) => {
    originalPush.call(
      this,
      location,
      () => {
        // on complete

        resolve(this.currentRoute);
      },
      error => {
        resolve(this.currentRoute);
      }
    );
  });
};

router.onError(err => {
  console.log("<!-- router error: " + err.message + " -->");
});
router.beforeEach((to, from, next) => {
  const email = Cookies.get("email");
  const employeeId = Cookies.get("employee-id");
  const token = Cookies.get("user-token");

  // Detect if the route is a guest route
  const isGuest = to.path.startsWith("/guest");

  // Fix: Ensure we do not mistakenly log out authenticated users
  if (!isGuest && !isLoggedIn() && email && employeeId) {
    document.body.style.opacity = 0;
    getEmployeeProfile(email, employeeId, null)
      .then(result => {
        if (result && result.data && result.data.attributes) {
          setAccessToken(token);
          store.commit("UPDATE_EMPLOYEE", result.data);
          store.commit("SET_EMPLOYEE", result.data);
          document.body.style.opacity = 1;
          next();
        }
      })
      .catch(() => {
        next({ name: "Login" });
      });
    return;
  }

  if (isGuest) {
    // Allow guest users to navigate freely
    next();
    return;
  }

  const role = store.state.currentEmp?.role;
  const teamAdmin = store.state.currentEmp?.team_admin;

  const adminAccount = store?.state?.employee?.employees?.find(
    employee =>
      (employee.attributes.role == "admin" ||
        employee.attributes.role == "team_admin") &&
      !employee.attributes.soft_deleted &&
      employee?.attributes?.active
  );

  const softDeletedEmployee =
    store.state.currentOrganization?.attributes?.soft_deleted &&
    !store.state?.currentOrganization?.attributes?.active;

  store.commit("HIDE_ADMIN_MENU");
  store.commit("RESET_ADMIN_BUTTON_MENU");

  if (from.meta.officeAdmin === true) clearPKToken();

  if (to.meta.officeAdmin === true && window.innerWidth < 768) {
    store.commit("SHOW_ADMIN_BUTTON_MENU");
  } else {
    store.commit("SHOW_ADMIN_MENU");
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // Fix: Prevent redirection if the user is logged in correctly
  if (!isGuest && !isLoggedIn() && to.meta.private) {
    next({ name: "Login", query: { from: window.location.pathname } });
    return;
  }

  if (
    !isGuest &&
    ((role && role == "admin") || teamAdmin) &&
    to.meta.officeAdmin === true
  ) {
    next();
    return;
  }

  if (
    !isGuest &&
    softDeletedEmployee &&
    to.name != "Profile" &&
    to.name != "Orders" &&
    to.name != "Faq"
  ) {
    next("./orders");
    return;
  }

  if (
    !isGuest &&
    to.meta.private &&
    from.name !== "Login" &&
    store?.state?.employee?.email &&
    store?.getters?.getFirstEmployeeId
  ) {
    getEmployeeProfile(
      store.state.employee.email,
      store.getters.getFirstEmployeeId,
      store.state.currentOrganization
    ).then(result => {
      if (result && result.data && result.data.attributes) {
        store.commit("UPDATE_EMPLOYEE", result.data);
      }
    });
  }

  if (!isGuest && to.meta.private && !isLoggedIn()) {
    next({ name: "Login", query: { from: window.location.pathname } });
    return;
  } else if (!isGuest && to.meta.redirectIfLoggedIn && isLoggedIn()) {
    next("./restaurants");
    return;
  } else if (!isGuest && to.meta.error404 && !isLoggedIn()) {
    window.location.href = "https://www.hungerhub.com/404/";
    return;
  } else if (
    !isGuest &&
    isLoggedIn() &&
    adminAccount?.id &&
    !employeeId &&
    !token &&
    !email
  ) {
    logOut({ $store: store, $router: router });
    return;
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js